/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';

import { Container, Margin, Padding } from '../../common/base';
import { Grid, Col, Anchor } from '../../common/interfaces';
import { Wrapper, Title } from './Styled';
import { withTranslation } from '../../common/libs/i18n';

const K_PICTURES = [
  {
    name: 'Harvard Business School',
    image: '/static/images/dna/harvard.png'
  },
  {
    name: 'Massachusetts Institute of Technology',
    image: '/static/images/dna/mit.png'
  },
  {
    name: 'The University of Texas at Austin',
    image: '/static/images/dna/texas.png'
  },
  {
    name: 'Universitas Indonesia',
    image: '/static/images/dna/ui.png'
  },
  {
    name: 'ConsenSys',
    image: '/static/images/dna/consensys.png'
  }
];

const HomeReports = ({ t }) => {
  return (
    <Wrapper>
      <Container>
        <Title>
          <Grid justify="center">
            <Col lg={6} sm={12} text="center">
              <h2>{t('landing.meet_the_teem.title', 'Meet the Team')}</h2>
              <p>
                {t(
                  'landing.meet_the_teem.subtitle',
                  'We are alumni of top universities and tech unicorns who are incredibly passionate about driving positive change in Indonesia. We believe that Blockchain has the power to improve financial inclusivity and eradicate the difficulty of sending funds between parties.'
                )}
              </p>
              <Margin vertical={24}>
                <Anchor type="button" size="large" href="/about">
                  {t('landing.meet_the_teem.button', 'Meet our team')}
                </Anchor>
              </Margin>
            </Col>
            <Col lg={12} md={12} sm={12} text="center">
              <Grid justify="center">
                {K_PICTURES.map((item, idx) => (
                  <Col
                    key={idx}
                    lg={2}
                    md={6}
                    sm={12}
                    style={{
                      display: 'inline-block',
                      height: '96px',
                      verticalAlign: 'middle'
                    }}
                  >
                    <img
                      style={{
                        display: 'block',
                        maxHeight: '100%',
                        height: 'auto',
                        width: 'auto',
                        margin: '0 auto',
                        padding: '12px'
                      }}
                      src={item.image}
                      alt={item.name}
                    />
                  </Col>
                ))}
              </Grid>
            </Col>
          </Grid>
        </Title>
      </Container>
    </Wrapper>
  );
};

HomeReports.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(HomeReports);
